export const CLASSES = {
  ACTIVE: "is-active",
  DISABLED: "is-disabled",
  OPEN: "is-open",
  HIDDEN: "is-hidden",
  VISIBLE: "is-visible",
  FOCUSED: "is-focused",
  SELECTED: "is-selected",
  EDITABLE: "is-editable",
  EDITING: "is-editing",
  LOADER: "loader",
  LOADER_WRAPPER: "loader-wrapper",
  FORM_INPUT: "form-input",
  FORM_CHECKBOX: "checkbox",
  FORM_SUBMIT: "form-submit",
  TOOLTIP_ACTIVE: "tooltipstered"
};

export const STRINGS = {
  DEFAULT_ERROR_MESSAGE: "Something went wrong. Try again.",
  EMAIL_ERROR_MESSAGE: "Enter a valid email address.",
  REQUIRED_FIELD_ERROR_MESSAGE: "This field is required.",
  AGREEMENT_ERROR_MESSAGE: "Agree with the Terms and Conditions to continue.",
  CREDIT_CARD_FIRST_NAME_ERROR_MESSAGE:
    "Enter your first name as it appears on your credit card.",
  CREDIT_CARD_LAST_NAME_ERROR_MESSAGE:
    "Enter your last name as it appears on your credit card.",
  CREDIT_CARD_NUMBER_ERROR_MESSAGE: "Enter your credit card number.",
  CREDIT_CARD_EXP_DATE_ERROR_MESSAGE:
    "Enter your credit card's expiration date.",
  CREDIT_CARD_SECURITY_CODE_ERROR_MESSAGE:
    "Enter your credit card's security code.",
  CREDIT_CARD_ZIP_CODE_ERROR_MESSAGE: "Enter your billing zip code.",
  PASSWORD_CONFIRMATION_ERROR:
    "New password and confirmation password do not match.",
  PASSWORD_MIN_LENGTH_MESSAGE: "Password must be at least 6 characters"
};

export const KEYCODES = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ALT: 18,
  PAUSE_BREAK: 19,
  CAPS_LOCK: 20,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT_ARROW: 37,
  UP_ARROW: 38,
  RIGHT_ARROW: 39,
  DOWN_ARROW: 40,
  INSERT: 45,
  DELETE: 46,
  NUM_LOCK: 144,
  SCROLL_LOCK: 145
};

export const STATES = {
  al: "Alabama",
  ak: "Alaska",
  az: "Arizona",
  ar: "Arkansas",
  ca: "California",
  co: "Colorado",
  ct: "Connecticut",
  de: "Delaware",
  dc: "District of Columbia",
  fl: "Florida",
  ga: "Georgia",
  hi: "Hawaii",
  id: "Idaho",
  il: "Illinois",
  in: "Indiana",
  ia: "Iowa",
  ks: "Kansas",
  ky: "Kentucky",
  la: "Louisiana",
  me: "Maine",
  md: "Maryland",
  ma: "Massachusetts",
  mi: "Michigan",
  mn: "Minnesota",
  ms: "Mississippi",
  mo: "Missouri",
  mt: "Montana",
  ne: "Nebraska",
  nv: "Nevada",
  nh: "New Hampshire",
  nj: "New Jersey",
  nm: "New Mexico",
  ny: "New York",
  nc: "North Carolina",
  nd: "North Dakota",
  oh: "Ohio",
  ok: "Oklahoma",
  or: "Oregon",
  pa: "Pennsylvania",
  ri: "Rhode Island",
  sc: "South Carolina",
  sd: "South Dakota",
  tn: "Tennessee",
  tx: "Texas",
  ut: "Utah",
  vt: "Vermont",
  va: "Virginia",
  wa: "Washington",
  wv: "West Virginia",
  wi: "Wisconsin",
  wy: "Wyoming"
};

// eslint-disable-next-line no-unused-vars
const uslDevDomain = "https://uslforms.usl-dev.xyz";

export const ENDPOINTS = {
  LOGIN: `/api/login`,
  REGISTRATION: `/api/register`,
  GET_USER_INFO: `/api/user?include=subscription_integrations`,
  GET_USER_INFO_WITH_FORMS: `/api/v1/user?include=purchased_forms,subscription_based_forms,subscription_integrations`,
  GET_USER_INFO_WITH_FORMS_AND_PROJECTS: `/api/v1/user?include=purchased_forms,subscription_based_forms,projects,subscription_integrations`,
  GET_GATEWAY_TOKEN: `/api/payments/token`,
  CHARGE: `/api/payments/pay`,
  METHODS: `/api/payments/methods`,
  DEFAULT_METHOD: `/api/payments/methods/default`,
  GET_SUBSCRIPTION: `/api/user/subscription`,
  USER_INFO_V1: `/api/v1/user?include=subscription_integrations`,
  USER_INFO_EMAIL: `/api/v1/user/email`,
  USER_INFO_PASSWORD: `/api/v1/user/password`,
  VERIFY_EMAIL: `/api/v1/user/verify`,
  CANCEL_SUBSCRIPTION: `/api/v1/subscriptions/active/cancel`,
  FREE_UPGRADE_SUBSCRIPTION: `/api/v1/subscriptions/active/loyal-upgrade`,
  GET_ACTIVE_SUBSCRIPTION_V1: `/api/v1/subscriptions/active?include=plan`,
  GET_ALL_SUBSCRIPTIONS_V1: `/api/v1/subscriptions?include=plan`,
  UPGRADE_TO_PREMIUM: `/api/v1/subscriptions/active/upgrade`,
  GET_UPGRADE_PLANS_INFO: `/api/v1/subscriptions/active/upgrade-plans`,
  ADD_USER_TO_EXPERIMENT: `/api/v1/experiment/run`,
  GET_DEFINITIONS: `/api/v1/legal-definitions`,
  GET_HELPFUL_TOPICS: `/api/v1/helpful-topics`,
  GET_LEGAL_LIFE_ARTICLES: `/api/v1/legal-life-articles`,
  GET_LEGAL_QUESTIONS_CATEGORY: `/api/v1/questions-and-answers-categories`,
  GET_LEGAL_QUESTION: `/api/v1/questions-and-answers`,
  PLAN_INFO_PREMIUM: `/api/v1/plans?filter[is_premium]=1`,
  CREATE_DISCOUNT: `/api/v1/discounts`,
  SUBSCRIPTION_CANCEL_REASON_LIST: `/api/v1/subscription-cancelation-reason`,
  SUBSCRIPTION_CANCEL_ANSWER: `/api/v1/subscription-cancelation-reason-answer`,
  GET_SUBSCRIPTION_BASED_FORMS: `/api/v1/forms/subscription?include=related_forms`,
  GET_PURCHASED_FORMS: `/api/v1/forms/purchased?include=related_forms`,
  GET_PROJECT_FORMS: `/api/v1/user/projects`,
  USER_LOCATION: `/api/v1/user/location`,
  GET_USE_PURPOSE_QUESTIONS: `/api/v1/notifications/use-purpose-statistics/answers?include=questions`,
  STORE_USER_USE_PURPOSE_ANSWER: `/api/v1/notifications/answers/store`,
  CREATE_INCORPORATION_SERVICE: `/api/v1/incorporation-service`,
  GET_INFO_ABOUT_ALL_ORDERS: `/api/v1/orders`
};
